export default {
    DASHBOARD: "dashboard",
    LOGIN: "login",
    DAILY_REPORT: "reports",
    HISTORICS: "historics",
    USER_PROFILE: "userProfile",
    CONFIGS: "configs",
    RISK_ANALYSIS: "risk_analysis",
    ERRORS: "errors",
    VIEW_ONLY_SILO: "view_silo",
    INSURANCE: "insurance",
}